'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = require('./components/Pagination.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pagination).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/pagination/lib/index.js
// module id = 92
// module chunks = 1